import { ref, computed } from "vue";
//@ts-ignore
import { decodeTextWithEntities } from "@utils/StringUtils";
export function usePlaceName() {
  var currentPlaceName = ref("");
  var locationLabel = computed(() => decodeTextWithEntities(window["_labels"].locality));
  var zonesLabel = computed(() => decodeTextWithEntities(window["_labels"].zones));
  var setCustomPlaceLabel = label => {
    currentPlaceName.value = "".concat(label);
  };
  var updateLocationName = locality => {
    if (!locality || !locality.localityID) return;
    currentPlaceName.value = "".concat(locality.cityName, " (").concat(locality.provinceAcronym, ") - ").concat(locationLabel.value, " ").concat(locality.localityName);
  };
  var updateZoneName = (zone, selectedZones) => {
    var _a;
    if (!zone) return;
    //Sebastian R.S: In case there are no selected zones
    if (!selectedZones) return;
    if (selectedZones === 1) {
      updateGenericPlaceName(zone);
      return;
    }
    //Sebastian R.S: If the selected zones are more than 1...
    currentPlaceName.value = "".concat((_a = zone.cityName) !== null && _a !== void 0 ? _a : zone.displayName, " - ").concat(selectedZones, " ").concat(zonesLabel.value);
  };
  var updateSingleDistrictName = district => {
    if (!district) return;
    currentPlaceName.value = "".concat(district.cityName, " (").concat(district.provinceAcronym, ") - ").concat(district.districtName);
  };
  var updateGenericPlaceName = place => {
    if (!place) return;
    currentPlaceName.value = place.displayName;
  };
  var updateCityName = city => {
    if (!city) return;
    currentPlaceName.value = "".concat(city.cityName, " (").concat(city.provinceAcronym, ")");
  };
  return {
    currentPlaceName,
    //Refs
    locationLabel,
    zonesLabel,
    //Computed
    //Methods
    setCustomPlaceLabel,
    updateLocationName,
    updateZoneName,
    updateSingleDistrictName,
    updateGenericPlaceName,
    updateCityName
  };
}